import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import React from 'react'
import AIDisclaimerDialog from 'components/AIDisclaimerDialog'

const useStyles = makeStyles((theme: Theme) => ({
    text: {
        color: '#304959',
        fontSize: pxToRem(14),
        lineHeight: pxToRem(20),
        marginBottom: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    bold: {
        fontWeight: 600,
    },
}))

/** Props for {@link SpecIntelligenceInfoDialog}. */
export interface SpecIntelligenceInfoDialogProps {
    /** Whether the dialog is open. */
    open: boolean
    /** Called when the dialog requests to be closed. */
    onClose: () => void
}

/** AI disclaimer dialog for Spec Intelligence, opened from the drawer info button. */
const SpecIntelligenceInfoDialog = ({ open, onClose }: SpecIntelligenceInfoDialogProps) => {
    const classes = useStyles()
    return (
        <AIDisclaimerDialog open={open} onClose={onClose}>
            <Typography className={classes.text}>
                Spec Intelligence uses AI to review your project specification
                sections and identify potential issues including errors and
                omissions, cross-section coordination gaps, missing submittals,
                and contradictory language.
            </Typography>
            <Typography className={classes.text}>
                <span className={classes.bold}>Legal Disclaimer: </span>
                The findings generated by Spec Intelligence are provided for
                informational purposes only and are intended to assist specifiers
                in their review process. AI-generated analysis does not constitute
                professional engineering, architectural, or legal advice.
            </Typography>
            <Typography className={classes.text}>
                All findings should be independently verified by a qualified
                professional before being relied upon. Deltek and its affiliates
                make no representations or warranties, express or implied,
                regarding the accuracy, completeness, or fitness for a particular
                purpose of any AI-generated content.
            </Typography>
            <Typography className={classes.text}>
                By using Spec Intelligence, you acknowledge that AI-generated
                suggestions may contain errors and that you are solely responsible
                for any decisions made based on this analysis. Users should apply
                their professional judgment and verify all recommendations in
                accordance with applicable codes, standards, and project
                requirements.
            </Typography>
        </AIDisclaimerDialog>
    )
}

export default SpecIntelligenceInfoDialog
